import ApiService from "../ApiService";

const reprocessService = {
    updateOrderReprocess(startDate, endDate) {
        return ApiService.post(`reprocess/?startDate=${startDate}&endDate=${endDate}`);
    }

}
export default reprocessService;